import { FormGroupRules } from '@shared/models/interfaces/form-group-rules.model';
import { addRemoveError, getControl } from '@shared/helpers/form.helper';
import { FormGroup } from '@angular/forms';
import { INCONSISTENT_CHOICE, INVALID_DATE, REQUIRED_STATUS } from '@shared/constants/shared.constants';
import { isNilOrEmpty } from '@shared/helpers/utils.helper';
import { isEqual } from 'lodash-es';
import { toNum } from '@shared/helpers/math.helper';
import { Utilities } from '@core/helpers/utilities';
import { checkNormeRedazRegolam, getBaseSocialeControl, normeRedazRegolamHelper } from './helpers/base-sociale-form.helper';

export const baseSocialeRegolamentoRules: FormGroupRules = {
    my_CkRedazRegolam: (form: FormGroup) => {
        const my_CkRedazRegolamControl = getBaseSocialeControl(form, 'my_CkRedazRegolam');
        const my_CkNormeSocioLavorat = toNum(getBaseSocialeControl(form, 'my_CkNormeSocioLavorat')?.value);
        const errors = my_CkRedazRegolamControl.errors ? my_CkRedazRegolamControl.errors : {};

        addRemoveError(isNilOrEmpty(my_CkRedazRegolamControl?.value) && my_CkNormeSocioLavorat === 1, errors, 'my_CkRedazRegolam', {
            status: REQUIRED_STATUS,
        });

        my_CkRedazRegolamControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_ChkRegolamentoCertificato: (form: FormGroup) => {
        normeRedazRegolamHelper(form, 'my_ChkRegolamentoCertificato');
    },

    my_CkContrattoCollLavSub: (form: FormGroup) => {
        normeRedazRegolamHelper(form, 'my_CkContrattoCollLavSub');
    },

    my_CkRegolSvolgLav: (form: FormGroup) => {
        normeRedazRegolamHelper(form, 'my_CkRegolSvolgLav', true, {
            status: REQUIRED_STATUS,
            message: 'Una scelta deve essere effettuata obbligatoriamente.',
        });
    },

    my_CkRegolNormeNonSub: (form: FormGroup) => {
        normeRedazRegolamHelper(form, 'my_CkRegolNormeNonSub');
    },

    my_CkRegolAssPianoCrisi: (form: FormGroup) => {
        normeRedazRegolamHelper(form, 'my_CkRegolAssPianoCrisi');
    },

    my_CkRegolAssPiano2: (form: FormGroup) => {
        normeRedazRegolamHelper(form, 'my_CkRegolAssPiano2');
    },

    my_CkRegolAvvNuove: (form: FormGroup) => {
        normeRedazRegolamHelper(form, 'my_CkRegolAvvNuove');
    },

    my_CkCoopTraPro: (form: FormGroup) => {
        normeRedazRegolamHelper(form, 'my_CkCoopTraPro');
    },

    my_CkRegolamentoConforme: (form: FormGroup) => {
        normeRedazRegolamHelper(form, 'my_gruppo20.my_CkRegolamentoConforme');
        const idAssegnazione = toNum(getControl(form, 'my_IdAssegnazione')?.value);
        const my_CkRegolamentoConformeControl = getBaseSocialeControl(form, 'my_gruppo20.my_CkRegolamentoConforme');
        const my_CkRegolamentoConforme = toNum(my_CkRegolamentoConformeControl?.value);
        const my_CkContrattoCollLavSub = toNum(getBaseSocialeControl(form, 'my_CkContrattoCollLavSub')?.value);
        const my_CkCoopTraPro = toNum(getBaseSocialeControl(form, 'my_CkCoopTraPro')?.value);
        const my_CkRegolSvolgLav = toNum(getBaseSocialeControl(form, 'my_CkRegolSvolgLav')?.value);
        const my_CkRegolNormeNonSub = toNum(getBaseSocialeControl(form, 'my_CkRegolNormeNonSub')?.value);
        const my_CkRegolAssPianoCrisi = toNum(getBaseSocialeControl(form, 'my_CkRegolAssPianoCrisi')?.value);
        const my_CkRegolAssPiano2 = toNum(getBaseSocialeControl(form, 'my_CkRegolAssPiano2')?.value);
        const firstCondition = my_CkRegolamentoConforme === 1 && my_CkContrattoCollLavSub === 0 && my_CkCoopTraPro !== 1 && idAssegnazione != 268_614;
        const secondCondition =
            my_CkRegolamentoConforme === 1 && (my_CkRegolSvolgLav === 0 || my_CkRegolNormeNonSub === 0 || my_CkRegolAssPianoCrisi === 0 || my_CkRegolAssPiano2 === 0);
        const errors = my_CkRegolamentoConformeControl.errors ? my_CkRegolamentoConformeControl.errors : {};

        addRemoveError(firstCondition || secondCondition, errors, 'my_CkRegolamentoConforme', {
            status: INCONSISTENT_CHOICE,
        });

        my_CkRegolamentoConformeControl.setErrors(isEqual(errors, {}) ? null : errors);
    },

    my_NoteRegNonConforme: (form: FormGroup) => {
        const my_CkRegolamentoConforme = toNum(getBaseSocialeControl(form, 'my_gruppo20.my_CkRegolamentoConforme')?.value);
        normeRedazRegolamHelper(form, 'my_NoteRegNonConforme', my_CkRegolamentoConforme === 0);
    },

    my_DataDeposUfficio: (form: FormGroup) => {
        const my_NoteDataDeposUfficio: string = getBaseSocialeControl(form, 'my_NoteDataDeposUfficio')?.value;
        normeRedazRegolamHelper(form, 'my_DataDeposUfficio', isNilOrEmpty(my_NoteDataDeposUfficio), {
            status: 'Inserire Data Deposito o Note',
            message: 'Data Deposito e Note non possono essere entrambi vuoti.',
        });
    },

    my_NoteDataDeposUfficio: (form: FormGroup) => {
        const my_DataDeposUfficio: string = getBaseSocialeControl(form, 'my_DataDeposUfficio')?.value;
        normeRedazRegolamHelper(form, 'my_NoteDataDeposUfficio', isNilOrEmpty(my_DataDeposUfficio), {
            status: 'Inserire Data Deposito o Note',
            message: 'Data Deposito e Note non possono essere entrambi vuoti.',
        });
    },

    my_dataApprovAssemb: (form: FormGroup) => {
        const my_DataApprovAssembControl = getBaseSocialeControl(form, 'my_DataApprovAssemb');
        const my_DataDeposUfficio: string = getBaseSocialeControl(form, 'my_DataDeposUfficio')?.value;
        const errors = my_DataApprovAssembControl.errors ? my_DataApprovAssembControl.errors : {};
        const showError =
            checkNormeRedazRegolam(form) &&
            (isNilOrEmpty(my_DataApprovAssembControl?.value) ||
                (!isNilOrEmpty(my_DataDeposUfficio) && Utilities.isDateAfter(my_DataApprovAssembControl?.value, my_DataDeposUfficio)));

        addRemoveError(showError, errors, 'dataApprovAssemb', {
            status: INVALID_DATE,
            message: 'La data deve essere inserita obbligatoriamente e deve essere precedente alla data di deposito.',
        });

        my_DataApprovAssembControl.setErrors(isEqual(errors, {}) ? null : errors);
    },
};
